import React from 'react';

import Widgets, { type Link } from 'ui/src/components/Widgets';
import WidgetCard from 'ui/src/components/Widgets/WidgetCard';
import WidgetHeader from 'ui/src/components/Widgets/_components/WidgetHeader';

import WidgetStickyZone from 'ui/src/components/Widgets/WidgetStickyZone';
import WidgetTalents from 'ui/src/components/Widgets/_components/WidgetTalents';
import WidgetLinks from 'ui/src/components/Widgets/_components/WidgetLinks';
import WidgetQuote from 'ui/src/components/Widgets/_components/WidgetQuote';
import WidgetList from 'ui/src/components/Widgets/_components/WidgetList';

import { widgets } from 'data/widgets';

/**
 * Blog Widgets Components
 */

interface Props {
  relatedServices: Link[];
  relatedArticles: Link[];
}

export default function BlogWidgets({ relatedServices, relatedArticles }: Props) {
  return (
    <Widgets>
      <WidgetCard className="bg-site-accent-25 border-site-accent-200 hidden md:flex">
        <WidgetHeader title={widgets.hiringEngineers.title} />
        <WidgetTalents {...widgets.hiringEngineers} />
      </WidgetCard>

      <WidgetStickyZone>
        <WidgetCard className="bg-site-accent-25 border-site-accent-200">
          <WidgetHeader title={widgets.hiringEngineers.title} />
          <WidgetTalents {...widgets.hiringEngineers} />
        </WidgetCard>

        {!!relatedServices.length && (
          <WidgetCard className="border-site-secondary-green-200 sticky top-32">
            <WidgetHeader title={widgets.relatedServices.title} className="bg-site-secondary-green-25" />
            <WidgetLinks links={relatedServices} />
          </WidgetCard>
        )}

        <WidgetCard className="border-site-neutrals-100 sticky top-32 mt-4">
          <WidgetQuote {...widgets.quote} />
        </WidgetCard>

        {!!relatedArticles.length && (
          <WidgetCard className="border-site-accent-200 sticky top-32">
            <WidgetHeader title={widgets.relatedArticles.title} className="bg-site-accent-25" />
            <WidgetList items={relatedArticles} />
          </WidgetCard>
        )}
      </WidgetStickyZone>
    </Widgets>
  );
}
